module.exports = __webpack_public_path__ + "img/keyboard_T.ce1ec67f.png";